import { useEffect, useRef, useState } from "react";
import { db } from "@react-native-firebase/database";
import { getAuth } from "firebase/auth";
import { ActivityIndicator } from "react-native";
import { push, ref, get, update,set, onChildChanged,Unsubscribe } from "firebase/database";
import Menu from "./Menu";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "core/helpers";
import { MOBILE_VIEW_WIDTH } from "res/constants";
import { Dimensions } from "react-native";
import { formatDate, formatTime } from "src/utils/Date&TimeUtils";
import TimeTrackingTable from "src/components/TimeTrackingTable";
import StyleSheetRW from "core/StyleSheetRW";
import { rh } from "core/designHelpers";
import Loader from "src/components/Loader";
import { fetchUserName } from "src/utils/UserUtils";
import DropDownField from "src/components/DropDownField";
import Dialog from "src/components/Dialog";
import moment from "moment";
import { IStatuses, IUserStatus } from "src/interfaces/IStatuses";
import { requestNotificationPermission } from "src/commons";






interface CountingTimer {
  hours: number;
  minutes: number;
  seconds: number;
}

interface ProjectData {
  id: string;
  title: string;
}



export default function HomeScreen() {
  const [startTimeEntryKey, setStartTimeEntryKey] = useState<string | null>(null);
  const [timeRecords, setTimeRecords] = useState([]);
  const [countingTimer, setCountingTimer] = useState<CountingTimer>({ hours: 0, minutes: 0, seconds: 0 });
  const screenWidth = Dimensions.get('window').width;
  const timerContainerStyle = { ...styles.timerContainer, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column-reverse' : 'row', borderRadius: screenWidth < MOBILE_VIEW_WIDTH ? 40 : 16, };
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  // const loggedinUser = getLocalStorageItem("loggedinUser");
  const [userName, setUserName] = useState("")
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [projects, setProjects] = useState<ProjectData[]>([]);
  const [selectedProject, setSelectedProject] = useState<any>({
    "id": "-O29PgEal5FlmVsVogpS",
    "title": "AfroCart"
}); // default ""
  const [showTaskSummaryDialog, setShowTaskSummaryDialog] = useState<boolean>(false);
  const [taskSummary, setTaskSummary] = useState<string>("");
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isStarting, setIsStarting] = useState<boolean>(false);
  const [isStoping, setIsStoping] = useState<boolean>(false);
  const [isPausing, setIsPausing] = useState<boolean>(false);

  var userTrackingStartTime: string | null = null;
  var userTrackingStartDate = null;
  var userTrackingProjectName = null;



  const isTabActive = useRef(true);
  const auth = getAuth();
  const loggedInUserId = auth.currentUser?.uid;

  

  function listenToStatusUpdates(callback: (userid: string, status: string) => void): Unsubscribe {
    const statusesRef = ref(db, "statuses"); 
    
  // Listen for child changes
  const unsubscribe =onChildChanged(statusesRef, (snapshot) => {
    const userid = snapshot.key; 
    const status = snapshot.val()?.currentStatus; 

    if (userid && status !== undefined) {
      console.log(`Status change detected for ${userid}: ${status}`);
      callback(userid, status); // Invoke the callback with userid and status
    }
  });
      return unsubscribe; // Return the unsubscribe function

  }



// Function to handle status changes
  const handleStatusChange = async (userId: string, currentStatus: string) => {
  
  // console.log(`Handling status change for userId: ${userId}`);
  // const loggedinUser = getLocalStorageItem("loggedinUser");
  // console.log("Logged in user user id", loggedinUser.uid)
  // console.log("status changed user id",userId)
  if (userId !== loggedInUserId)
  {
    try {
      const userRef = ref(db, `profile/${userId}`); 
      const snapshot = await get(userRef);
      const currentHourMinute = moment().format("hh:mm A");
      if (snapshot.exists())
      {
        const user = snapshot.val();

        showNotification(
          "Staff Docker",
          `${user.firstName}${user.lastName} has ${currentStatus} working  at ${currentHourMinute}`
        );
      }
    } catch (error)
    {
        console.error("Error fetching profile or sending notification:", error);

    }
  }
  
};


  const getUserTimeRecords = async () => {
    try {
      if (loggedInUserId) {
        const dbRef = ref(
          db,
          `timeRecord/${loggedInUserId}`
        );
        await get(dbRef)
          .then((snapshot) => {
            if (snapshot.exists()) {
              const data = snapshot.val();
              const records = [];
              Object.keys(data).forEach((dateKey) => {
                const recordArray = Object.keys(data[dateKey]).map((TimeEntryKey) => {
                  if (dateKey === formatDate(new Date(), "YYYY-MM-DD") && data[dateKey][TimeEntryKey].endTime == null) {
                    calculateTimeElapsed(data[dateKey][TimeEntryKey].startTime);
                    setStartTimeEntryKey(TimeEntryKey);
                  }
                  const { startTime, endTime, duration, projectName, taskSummary,updatedAt } = data[dateKey][TimeEntryKey];
                  return { startTime, endTime, duration, projectName, taskSummary,updatedAt, uid: TimeEntryKey, };
                });
                records.push({ date: dateKey, records: recordArray });
              });
              setTimeRecords(records.reverse());
              setShowLoader(false);
            } else {
              setShowLoader(false);
              console.log("No data available for the specified date.");
            }
          })
          .catch((error) => {
            setShowLoader(false);
            console.error("Failed to retrieve data:", error);
          });
      }
    } catch (error) {
      setShowLoader(false);
      console.error("Error reading data:", error.message);
    }
  };



  const getProjectRecords = async () => {
    try {
      if (loggedInUserId) {
        const dbRef = ref(db, "projectRecord");
        await get(dbRef)
          .then((snapshot) => {
            if (snapshot.exists()) {
              const data = snapshot.val();
              const projectNameArray: ProjectData[] = [];
              Object.keys(data).forEach((userID) => {
                Object.keys(data[userID]).forEach((projectID) => {
                  const { projectName } = data[userID][projectID];
                  projectNameArray.push({ id: projectID, title: projectName });
                });
              });
              setProjects(projectNameArray);
            } else {
              console.log("No projects available.");
            }
          })
          .catch((error) => {
            console.error("Failed to retrieve projects:", error);
          });
      }
    } catch (error: any) {
      console.error("Error reading projects:", error.message);
    }
  };

  const calculateTimeElapsed = (startTime: string | null) => {
  if (!startTime) return;

  const now = moment();
  const then = moment(startTime, 'h:mm:ss A');
  const duration = moment.duration(now.diff(then));

  setCountingTimer({
    hours: Math.floor(duration.asMinutes() / 60),
    minutes: Math.floor(duration.asMinutes() % 60),
    seconds: Math.floor(duration.asSeconds() % 60),
  });
};

  
  const getUserName = async () => {
    const name = await fetchUserName()
    setUserName(name);
  };

  useEffect(() => {
    setShowLoader(true)
    getUserName();
    getUserTimeRecords();
    getProjectRecords();
    requestNotificationPermission();
    listenToStatusUpdates(handleStatusChange);
     const unsubscribe = listenToStatusUpdates(handleStatusChange);
  return () => unsubscribe(); // Cleanup on unmount
  }, []);




  async function startTimer() {
  if (!selectedProject) {
    setDialogMessage("Please select a project to start the timer.");
    setShowAlertDialog(true);
    return;
  }
  
    setIsStarting(true);
  try {
    // const loggedinUser = getLocalStorageItem("loggedinUser");
    if (loggedInUserId) {
      const formattedDate = moment().format("YYYY-MM-DD");
      const dbRef = ref(db, `timeRecord/${loggedInUserId}/${formattedDate}`);
      const currentTime = moment().format("h:mm:ss A");

      const data = {
        startTime: currentTime,
        endTime: null,
        projectName: selectedProject.title,
        updatedAt: moment().valueOf()
      };
      // console.log("Data",data)
      

      // Push new time record
      await push(dbRef, data)
        .then(async (resData: any) => {
          const entryKey = resData!._path!.pieces_![3];
          setStartTimeEntryKey(entryKey);
          userTrackingStartDate = currentTime;
          userTrackingStartDate = formattedDate;
          userTrackingProjectName = selectedProject;

          setTimeRecords((prevRecords) => {
            const updatedRecords = [...prevRecords];
            const todayRecordIndex = updatedRecords.findIndex(
              (record) => record.date === formattedDate
            );
            if (todayRecordIndex !== -1) {
              updatedRecords[todayRecordIndex].records.push({
                startTime: currentTime,
                endTime: null,
                projectName: selectedProject.title,
                taskSummary: "",
                uid: entryKey,
              });
            } else {
              updatedRecords.unshift({
                date: formattedDate,
                records: [
                  {
                    startTime: currentTime,
                    endTime: null,
                    projectName: selectedProject.title,
                    taskSummary: "",
                    uid: entryKey,
                  },
                ],
              });
            }
            return updatedRecords;
          });

          // Update user status
          let userStatus = "Started";
          await ensureStatusesCollectionExistsAndSetUserStatus(loggedInUserId, {
            currentStatus: userStatus,
            timeStamp: new Date().toISOString(),
          });
        })
        .catch((error) => {
          console.error("Failed to save data:", error);
        });
    }
  } catch (error) {
    console.error("Error adding document: ", error);
  }
  finally {
    setIsStarting(false);
    }
}


async function ensureStatusesCollectionExistsAndSetUserStatus(
  userId: IStatuses,
  statusData: IUserStatus
) {
  const statusesRef = ref(db, `statuses/${userId}`);

  try {
    const snapshot = await get(statusesRef);

    if (!snapshot.exists()) {
      // If the user's status doesn't exist, create it
      await set(statusesRef, statusData);
    } else {
      // Update the user's status
      await update(statusesRef, statusData);
    }

    console.log(`User ${userId}'s status updated:`, statusData);
  } catch (error) {
    console.error("Error updating status:", error);
  }
}


  const showNotification = (title: string, message: string) => {
  if (Notification.permission === "granted") {
    new Notification(title, { body: message });
  } else {
    console.log("Notification permission not granted.");
  }
};
  const endTimer = async () => {
    if (!taskSummary) {
      setDialogMessage("Please enter a task summary to stop the timer.");
      setShowAlertDialog(true);
      return;
    }
      setIsStoping(true);
    try {
      // const loggedinUser = getLocalStorageItem("loggedinUser");
      if (loggedInUserId) {
        const formattedDate = moment().format("YYYY-MM-DD");
        const dbRef = ref(db, `timeRecord/${loggedInUserId}/${formattedDate}/${startTimeEntryKey}`);
        calculateTimeElapsed(userTrackingStartTime);
        const data = {
          endTime: moment().format("h:mm:ss A"),
          duration: formatTime(countingTimer),
          taskSummary: taskSummary,
          updatedAt: moment().valueOf()
        };

        // Update the time record in the database
        await update(dbRef, data);

        // Reset timer and local storage values
        setCountingTimer({ hours: 0, minutes: 0, seconds: 0 });
        getUserTimeRecords();
        setStartTimeEntryKey(null);
        userTrackingStartDate = null;
        userTrackingStartTime = null;
        setLocalStorageItem("userTrackingStartDate", null);
        setTaskSummary("");
        setShowTaskSummaryDialog(false);

        // Update the status for the user
        let userStatus = "Stopped";
        await ensureStatusesCollectionExistsAndSetUserStatus(loggedInUserId, {
          currentStatus: userStatus,
          timeStamp: new Date().toISOString(),
        });
        


      }
    } catch (error) {
      console.error("Error ending timer:", error);
    }
     finally {
    setIsStoping(false);
    }
  };
  const handlePauseTimer = async () => {
    setIsPausing(true);
    try {
      // const loggedinUser = getLocalStorageItem("loggedinUser");
      if (loggedInUserId) {
        const formattedDate = moment().format("YYYY-MM-DD");
        const dbRef = ref(db, `timeRecord/${loggedInUserId}/${formattedDate}/${startTimeEntryKey}`);
        calculateTimeElapsed(userTrackingStartTime);
        const data = {
          endTime:moment().format("h:mm:ss A"),
          duration: formatTime(countingTimer),
          updatedAt: moment().valueOf()
        };

        // Use await instead of .then() to ensure synchronous handling
        await update(dbRef, data);

        // Reset the timer values
        setCountingTimer({ hours: 0, minutes: 0, seconds: 0 });
        getUserTimeRecords();
        setStartTimeEntryKey(null);
        userTrackingStartDate = null;
        userTrackingStartTime = null;
        // Checking statuses collection and updating the user's status
        let userStatus = "Paused";
        await ensureStatusesCollectionExistsAndSetUserStatus(loggedInUserId, {
          currentStatus: userStatus,
          timeStamp: new Date().toISOString(),
        });

        

      }
    } catch (error) {
      console.error("Error pausing timer:", error);
    }
     finally {
    setIsPausing(false);
    }
  };


  const handleEndTimerClick = () => {
    setShowTaskSummaryDialog(true);
  };

useEffect(() => {
  if (userTrackingStartTime) {
    calculateTimeElapsed(userTrackingStartTime);
  }
}, []);



useEffect(() => {
  const handleVisibilityChange = async () => {
    if (!document.hidden) {
      // Tab is active, fetch fresh time records
      await getUserTimeRecords();
      
      // Find an active time entry and recalculate elapsed time
      if (startTimeEntryKey) {
        const formattedDate = moment().format("YYYY-MM-DD");
        const dbRef = ref(db, `timeRecord/${loggedInUserId}/${formattedDate}/${startTimeEntryKey}`);
        const snapshot = await get(dbRef);
        if (snapshot.exists()) {
          const data = snapshot.val();
          if (data.startTime && !data.endTime) {
            calculateTimeElapsed(data.startTime);
          }
        }
      }
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);
  return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
}, [startTimeEntryKey, loggedInUserId]);



  useEffect(() => {
    let interval: any;
    if (startTimeEntryKey) {
      interval = setInterval(() => {
        if (isTabActive) {
          setCountingTimer(prevTime => {
            let newSeconds = prevTime.seconds + 1;
            let newMinutes = prevTime.minutes;
            let newHours = prevTime.hours;
            if (newSeconds >= 60) {
              newSeconds = 0;
              newMinutes++;
            }
            if (newMinutes >= 60) {
              newMinutes = 0;
              newHours++;
            }
            return { ...prevTime, seconds: newSeconds, minutes: newMinutes, hours: newHours };
          });
        }
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [startTimeEntryKey, isTabActive]);

  //console.log(selectedProject)
  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: "100%" }}>
      <Menu />
      <div ref={scrollContainerRef} style={{ overflowX: "hidden", width: screenWidth < MOBILE_VIEW_WIDTH ? "90%" : "100%", padding: '0px 0px 0px 20px' }}>
        <div style={{ width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%", fontFamily: "Outfit", }}>
          <div style={{ width: "100%" }}>
            <h1 style={{ ...styles.heading, width: screenWidth >= MOBILE_VIEW_WIDTH ? "100%" : 153 }}>Welcome {userName}</h1>
            <DropDownField
              isObjectList={true}
              value={selectedProject?.title}
              placeholder="Select Project Name"
              bodyStyle={{ marginHorizontal: 0, }}
              options={projects}
              onChangeText={(selectedObj) => setSelectedProject(selectedObj)}
              label="Project Name"
            />
            <div style={timerContainerStyle}>
              <div style={{ display: 'flex', flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', width: '100%', gap: '10px', padding: "10px", alignItems: "center" }}>
              {startTimeEntryKey ? (
              <button
              style={{
              backgroundColor: '#2F4858',
              borderRadius: '9999px',
              fontWeight: 'lighter',
              fontSize: '14px',
              color: 'white',
              width: screenWidth < 850 && screenWidth > MOBILE_VIEW_WIDTH ? '120px' : screenWidth < MOBILE_VIEW_WIDTH ? '90%' : '150px',
              height: '40px',
              border: '0',
              cursor: 'pointer',
            }}
              onClick={handlePauseTimer}
              >
           {isPausing ? (
        <ActivityIndicator color={"#ffffff"}/>
        ) : (
        "Pause"
        )}
          </button>
            ) : (
          <button
          disabled={!!startTimeEntryKey || isStarting}
          style={{
          backgroundColor: startTimeEntryKey ? '#8c9ea2' : '#2F4858',
          borderRadius: '9999px',
          fontWeight: 'lighter',
          fontSize: '14px',
          color: 'white',
          width: screenWidth < 850 && screenWidth > MOBILE_VIEW_WIDTH ? '120px' : screenWidth < MOBILE_VIEW_WIDTH ? '90%' :     '150px',
          height: '40px',
          border: '0',
          cursor: startTimeEntryKey ? 'not-allowed' : 'pointer',
        }}
        onClick={startTimer}
        >
        {isStarting ? (
        <ActivityIndicator color={"#ffffff"}/>
        ) : (
        "Start"
        )}
      </button>
      )}

                <button disabled={!startTimeEntryKey} style={{ backgroundColor: startTimeEntryKey ? '#2F4858' : '#8c9ea2', borderRadius: '9999px', fontWeight: 'lighter', fontSize: '14px', color: 'white', width: screenWidth < 850 && screenWidth > MOBILE_VIEW_WIDTH ? "120px" : screenWidth < MOBILE_VIEW_WIDTH ? '90%' : '150px', height: '40px', border: '0', cursor: startTimeEntryKey ? 'pointer' : 'not-allowed' }} onClick={handleEndTimerClick}>
                 {isStoping ? (
                <ActivityIndicator color={"#ffffff"}/>

                ) : (
                "Stop"
                )}
                </button>
              </div>
              <div style={{ marginTop: 0, marginRight: 10, padding: '10px', display: 'flex', alignItems: 'baseline' }}>
                <span style={{ ...styles.timeText }}>{countingTimer.hours < 10 ? `0${countingTimer.hours}` : countingTimer.hours}:</span>
                <span style={{ ...styles.timeText }}>{countingTimer.minutes < 10 ? `0${countingTimer.minutes}` : countingTimer.minutes}:</span>
                <span style={{ fontSize: screenWidth < MOBILE_VIEW_WIDTH ? "36px" : '20px', fontWeight: 'medium', width: '1.2ch' }}>{countingTimer.seconds < 10 ? `0${countingTimer.seconds}` : countingTimer.seconds}</span>
              </div>
            </div>
            <TimeTrackingTable TimeTrackingRecords={timeRecords} getUserTimeRecords={getUserTimeRecords} scrollContainerRef={scrollContainerRef} projectNameData={projects} />
            {
              showLoader && <Loader />
            }
          </div>
        </div>
      </div>
      {showTaskSummaryDialog && (
        <div style={styles.overlay}>
          <div style={{ ...styles.taskSummaryDialog, width: screenWidth <= MOBILE_VIEW_WIDTH ? "70%" : undefined }}>
            <textarea
              value={taskSummary}
              onChange={(e) => setTaskSummary(e.target.value)}
              placeholder="Enter Task Summary"
              style={styles.taskSummaryInput}
            />
            <button style={styles.taskSummaryButton} onClick={endTimer}>Submit</button>
            <button style={styles.taskSummaryCancelButton} onClick={() => setShowTaskSummaryDialog(false)}>Cancel</button>
          </div>
        </div>
      )}
      <Dialog isDialogVisible={showAlertDialog} message={dialogMessage} onDialogClose={() => setShowAlertDialog(false)} />
    </div>
  );
}

const styles = StyleSheetRW.create(() => ({
  heading: { fontWeight: 'bold', fontSize: 32, color: '#2F4858', marginTop: 20 },
  timerContainer: { width: '100%', backgroundColor: '#e8f0eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', gap: '9px', paddingTop: "13px", paddingBottom: "13px" },
  timeText: { fontSize: 36, fontWeight: '500' },
  tableHeading: { fontSize: 20, fontWeight: 'bold', marginBottom: '10px' },
  tableHead: { padding: '8px', textAlign: 'left', borderBottom: '1px solid #2F4858', fontWeight: '300' },
  tableStyle: { width: "100%", borderCollapse: 'collapse', backgroundColor: '#FFFFFF66' },
  tableData1: { padding: '8px', borderLeft: '1px solid #2F485880' },
  body: { width: "100%", height: "100%", alignItems: "center", marginTop: rh(35) },
  overlay: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
    overflow: 'hidden',
  },
  taskSummaryDialog: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: 8,
    width: "299px",
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    position: "relative"
  },
  taskSummaryInput: {
    width: '97%',
    height: '100px',
    marginBottom: '10px',
    padding: '5px',
    border: '1px solid #ccc',
    borderRadius: 5,
    fontSize: '16px',
    resize: "none",
    fontFamily: "Outfit"
  },
  taskSummaryButton: {
    backgroundColor: '#2F4858',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    cursor: 'pointer',
    borderRadius: 100
  },
  taskSummaryCancelButton: {
    backgroundColor: 'white',
    color: '#2F4858',
    border: '1px solid #2F4858',
    padding: '10px 20px',
    cursor: 'pointer',
    borderRadius: 100,
    marginLeft: '10px',
  },
}))